import { useMutation } from 'query';

import { subscribe } from '../../services';
import type { DeliveryData, InfoData, PersonalData } from '../../types';

export const useSubscribeQuery = () =>
  useMutation<
    Record<string, unknown>,
    {
      deliveryData: DeliveryData;
      infoData: InfoData;
      personalData: PersonalData;
      programId: string;
    }
  >({
    async mutationFn({ deliveryData, infoData, personalData, programId }) {
      const subscribeResponse = await subscribe({
        deliveryData,
        infoData,
        personalData,
        programId,
      });

      return subscribeResponse.data;
    },
  });
